import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../core/i18n';
import { PublishedDateComponent } from './published-date.component';

@NgModule({
  declarations: [PublishedDateComponent],
  exports: [PublishedDateComponent],
  imports: [CommonModule, I18nModule],
})
export class PublishedDateModule {}
